import './speakerpopup.less'

import {Background} from '@codeurs/front'
import {SpeakerModel} from 'models/program/SpeakerModel'
import React from 'react'
import {ImageType, SummitType} from 'types'
import {useIsDark} from 'util/hooks'
import {style} from 'util/style'
import {PopupModal} from 'views/layout/popupmodal'
import {Sociallink} from 'views/layout/sociallink'
import {Summitlogo} from 'views/layout/summitlogo'
import {
	ProgramPopupLinks,
	ProgramPopupText,
	PropgramPopupTitle
} from '../programpopup'

const styles = style('speakerpopup', ['image', 'social', 'header', 'speakers'])

export const SpeakerPopup: React.FC<{
	speaker: SpeakerModel
}> = ({speaker}) => {
	const {
		image,
		firstname,
		lastname,
		company,
		linkedin,
		facebook,
		twitter,
		bio
	} = speaker.data
	const isDark = useIsDark()

	return (
		<div className={styles().mod({dark: isDark})}>
			<PopupModal.Content>
				<PopupModal.Left>
					<SpeakerPopupImage
						image={image}
						firstname={firstname}
						lastname={lastname}
						company={company}
						summits={speaker.summits}
					/>
					<SpeakerPopupSocial
						linkedin={linkedin}
						facebook={facebook}
						twitter={twitter}
					/>
				</PopupModal.Left>
				<PopupModal.Right>
					{/*<ProgramPopupHeader
						title="Title of the talk"
						start_time="9:00"
						end_time="9:30"
						location="Location of the talk"
					/>*/}
					<PropgramPopupTitle title="Biography" />
					<ProgramPopupText text={bio} />
				</PopupModal.Right>
			</PopupModal.Content>
			<ProgramPopupLinks sessions={speaker.sessions} />
		</div>
	)
}

export const SpeakerPopupImage: React.FC<{
	image: ImageType
	firstname: string
	lastname: string
	company: string
	summits: Array<SummitType>
}> = ({image, firstname, lastname, company, summits}) => {
	return (
		<div className={styles.image()}>
			{image && (
				<div className={styles.image('ratio')}>
					<div className={styles.image('ratio-bg')}>
						<Background img={image} />
					</div>
				</div>
			)}
			<div className={styles.image('overlay')} />
			<div className={styles.image('content')}>
				{(firstname || lastname) && (
					<p className={styles.image('content-name')}>
						{firstname + ' ' + lastname}
					</p>
				)}
				{company && (
					<p className={styles.image('content-company')}>{company}</p>
				)}
			</div>
			{summits && summits.length !== 0 && (
				<div className={styles.image('summit')}>
					{summits.map(summit => (
						<Summitlogo summit={summit} />
					))}
				</div>
			)}
		</div>
	)
}

export const SpeakerPopupSocial: React.FC<{
	linkedin: string
	facebook: string
	twitter: string
}> = ({linkedin, facebook, twitter}) => {
	if (!linkedin && !facebook && !twitter) return null

	return (
		<div className={styles.social()}>
			{linkedin && <Sociallink type={'linkedin'} url={linkedin} mod="big" />}
			{facebook && <Sociallink type={'facebook'} url={facebook} mod="big" />}
			{twitter && <Sociallink type={'twitter'} url={twitter} mod="big" />}
		</div>
	)
}
